import { Div, Line, Span } from "@tblabs/truffle";
import { Order } from "../../../../Models/Order";
import { BasketListInBasketInfo } from "../../OrdersView/Views/Table/Components/BasketList";
import { DiscountsList } from "./DiscountsList";


export class BasketInfo extends Div
{
    constructor(order: Order)
    {
        super();

        this.Append(
            new BasketListInBasketInfo(order, false).Margin(16),
            new Line(),
            new Span("Łącznie: " + order.BasketValue + "zł + " + order.DesiredDeposit + "zł kaucji").Margin(16),
            new Line(),
            new DiscountsList(order).Margin(16)
        );
    }
}
